<template>
  <main class="chapterhead" :class="`chapterhead--${bcolor}`">
    <div :style="{ display: gqlResult }">
      <pre>
        <code>{{ chapter }}</code>
      </pre>
    </div>
    <ChapterheadBanner :title="chapter.title" :image="chapter.featuredImage" />
    <section class="chapterhead__content">
      <a
        v-if="isLoggedIn"
        :href="editLink"
        target="_blank"
        class="chapterhead__button chapterhead__button--edit"
      >
        Edit
      </a>
      <img :src="chapter.imageUrl" class="chapterhead__image" />
      <div class="chapterhead__html" v-html="content" />
      <ChapterheadTOC />
    </section>
  </main>
</template>

<script>
import { get } from "lodash";
import ChapterheadBanner from "~/components/Chapterhead/ChapterheadBanner.vue";
import ChapterheadTOC from "~/components/Chapterhead/ChapterheadTOC.vue";

export default {
  name: "Chapterhead",
  components: {
    ChapterheadBanner,
    ChapterheadTOC,
  },
  props: {
    chapter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      gqlResult: "none",
    };
  },
  computed: {
    bcolor() {
      if (get(this, "chapter.color")) {
        return this.chapter.color;
      } else {
        return "#000000";
      }
    },
    content() {
      if (get(this, "chapter.content")) {
        return this.chapter.content.replace(/<body.*>/, "");
      }
      return "";
    },
    editLink() {
      const wp = process.env.WP_URL;
      const pageId = this.$store.state.chapter.current.pageId;
      return `${wp}/wp-admin/post.php?post=${pageId}&action=edit`;
    },
  },
  created() {
    // debugger;
  },
  methods: {
    isLoggedIn() {
      if (
        this.user.current &&
        this.user.current.username &&
        this.user.current.token
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.chapterhead {
  @include color-classes();
  @include clear();
  position: relative;
  flex-grow: 1;
  &__image {
    width: 50%;
    float: right;
    padding-bottom: 2rem;
  }
  &__content {
    color: white;
    font-style: italic;
    padding: 1rem 1rem 0 2rem;
    position: relative;
    p {
      margin-bottom: 0.8rem;
    }
    .wp-block-image {
      &:last-of-type {
        width: 50%;
        float: right;
        padding-bottom: 2rem;
      }
    }
  }
  &__html {
    max-width: 900px;
    width: calc(200% / 3);
  }
  &__button {
    @include button;
    border: 0;
    &--edit {
      font-style: normal;
      &:hover {
        background-color: green;
        color: white;
      }
    }
  }
}
</style>
